import { ALL_TAX_TYPES } from 'appConstants';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useGetSubscription } from 'store/subscription/actions';

import { ChangeBillingInfoModal } from '../ChangeModals';

export const BillingInfoTab = () => {
  const { data: subscription } = useGetSubscription();
  const [editOpen, setEditOpen] = useState(false);

  const returnFullAddress = () => {
    if (subscription?.address) {
      const { address } = subscription;
      return [
        address.state,
        address.city,
        address.line1,
        address.line2,
        address.postal_code,
      ]
        .filter(Boolean)
        .join(', ');
    }
    return '';
  };

  const activeTaxType = ALL_TAX_TYPES.find(
    (taxType) => taxType.value === subscription?.tax_type,
  );

  return (
    <>
      <section className="w-full">
        <div className="w-full flex items-start justify-between">
          <p className="text-lg font-semibold">
            <FormattedMessage id="billingInfo" />
          </p>
          <button
            type="button"
            onClick={() => setEditOpen(true)}
            className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          >
            <FormattedMessage id="edit" />
          </button>
        </div>
        <div className="w-full flex flex-col space-y-4">
          <div className="flex flex-col w-full space-y-1">
            <p className="text-base font-medium">
              <FormattedMessage id="billTo" />
            </p>
            <p className="text-base font-normal">{subscription?.name}</p>
          </div>
          <div className="flex flex-col w-full space-y-1">
            <p className="text-base font-medium">
              <FormattedMessage id="billingEmail" />
            </p>
            <p className="text-base font-normal">{subscription?.email}</p>
          </div>
          <div className="flex flex-col w-full space-y-1">
            <p className="text-base font-medium">
              <FormattedMessage id="billingAddress" />
            </p>
            <p className="text-base font-normal">{returnFullAddress()}</p>
          </div>
          <div className="flex flex-col w-full space-y-1">
            <p className="text-base font-medium">
              <FormattedMessage id="taxInfo" />
            </p>
            <p className="text-base font-normal">
              {activeTaxType?.label}: {subscription?.tax_value}
            </p>
          </div>
        </div>
      </section>
      <ChangeBillingInfoModal open={editOpen} setOpen={setEditOpen} />
    </>
  );
};
